import { render, staticRenderFns } from "./noteDetails.vue?vue&type=template&id=0873ee5e&scoped=true"
import script from "./noteDetails.vue?vue&type=script&lang=js"
export * from "./noteDetails.vue?vue&type=script&lang=js"
import style0 from "./noteDetails.vue?vue&type=style&index=0&id=0873ee5e&prod&lang=less"
import style1 from "./noteDetails.vue?vue&type=style&index=1&id=0873ee5e&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0873ee5e",
  null
  
)

export default component.exports